import { useEffect, useState, useRef } from 'react'
import TextBoxControl from "../../../Controls/TextBoxControl"
import ButtonControl from "../../../Controls/ButtonControl"
import Button from 'react-bootstrap/Button';
import { useNavigate } from "react-router-dom";
import "../../../assets/css/Login.css"
import {
	SetLocal,
	ClearLocal,
	FetchService,
	IsValidNationalCode,
	IsEmptyString,
	IsEmptyInput,
	GetLocal
} from "../../../Base/BaseControl";
import { toast } from 'react-toastify';
import { loadCaptchaEnginge, LoadCanvasTemplate, LoadCanvasTemplateNoReload, validateCaptcha } from 'react-simple-captcha';
import SelectControl from '../../../Controls/SelectControl';

export default function Index({ Click, page }) {
	const textBoxUserNameRef = useRef(null);
	const textBoxPasswordRef = useRef(null);

	const inputSelectRef = useRef(null);
	const [getSelectData, setSelectData] = useState([]);
	const [comboRegionDisabled, setComboRegionDisabled] = useState(true);
	const [isConnectionAttrributeCalled, setIsConnectionAttrributeCalled] = useState(false);


	const navigate = useNavigate();
	//const [nationalCode, checkNationalCode] = useState(true);

	useEffect(() => {
		loadCaptchaEnginge(5, 'white', 'black', 'numbers');
		document.querySelector('#reload_href').innerHTML = "کد امنیتی مجدد";
		document.querySelector('#reload_href').classList.add('refresh');

		document.getElementById('user_captcha_input').addEventListener('keydown', (event) => {
			if (event.keyCode === 13) {
				let user_captcha = document.getElementById('user_captcha_input').value;
				if (validateCaptcha(user_captcha) === true) {
					LoginSubmit();
				}
			}
		});
	}, []);

	useEffect(() => {
		var inputValue = {};
		FetchService("General/IsMultiRegion", inputValue, IsMultiRegionSuccess, IsMultiRegionFail);


	}, []);
	const IsMultiRegionSuccess = (ServiceResult) => {
		var inputValue = {};
		FetchService("General/Abstract/BasicInfo/ShowRegionAbstractList", inputValue, ShowRegionAbstractListSuccess);
	}
	const IsMultiRegionFail = (ServiceResult) => {
		setComboRegionDisabled(true)
	}

	const ShowRegionAbstractListSuccess = (ServiceResult) => {
		setSelectData(ServiceResult.RegionInfo);
		setComboRegionDisabled(false)

	}
	const GetConnetionAttribute = () => {
		let input = {
			regionCode: inputSelectRef.current?.value || 0,
		}
		FetchService("General/GetConnectionAttribute", input, GetConnetionAttributeSuccess)
	}
	const GetConnetionAttributeSuccess = (ServiceResult) => {
		if (ServiceResult) {
			setIsConnectionAttrributeCalled(true)
		}
	}


	const LoginSubmit = () => {
		if (IsEmptyInput(textBoxUserNameRef))
			return false;

		if (IsEmptyInput(textBoxPasswordRef))
			return false;

		if (!comboRegionDisabled && (!isConnectionAttrributeCalled || !inputSelectRef.current?.value)) {
			toast.error('لطفا منطقه را انتخاب نمایید');
			return false
		}

		let user_captcha = document.getElementById('user_captcha_input').value;
		if (!validateCaptcha(user_captcha) === true) {
			document.getElementById('user_captcha_input').style.border = "1px solid #ff0000cc"
			//toast.error('لطفا کد امنیتی را وارد نمایید');
			return false;
		}

		var inputValue = {
			userName: textBoxUserNameRef.current.value,
			password: textBoxPasswordRef.current.value,
			regionID: Number(inputSelectRef.current?.value) || 0
		};
		FetchService("Employee/Security/Login", inputValue, LoginSuccess);
	}

	const LoginSuccess = async (ServiceResult) => {
		localStorage.clear();
		await SetLocal('EmployeeSession', ServiceResult.sessionInfo.SessionValue);
		await SetLocal('RoleInfo', ServiceResult.roleInfo.Role);
		await SetLocal('FullName', ServiceResult.userInfo.FullName);
		GetMenuPrivilegeAccess(ServiceResult.sessionInfo.SessionValue);
	}

	const GetMenuPrivilegeAccess = (SessionValue) => {
		var inputValue = {
			session: SessionValue
		};
		FetchService("Employee/Security/GetMenuPrivilegeAccess", inputValue, GetMenuPrivilegeAccessSuccess);
	}

	const GetMenuPrivilegeAccessSuccess = async (ServiceResult) => {
		await SetLocal('EmployeeCode', JSON.stringify(ServiceResult.MenuListResult));
		navigate(`/Employee/FileSearch?page=جستجوی پرونده`);
	}



	return (
		<div id="bglogin">
			<div className="main">
				<div className="formLogin">
					<div className='my-3'>
						<SelectControl
							data={getSelectData}
							inputRef={inputSelectRef}
							title={"منطقه:"}
							required={!comboRegionDisabled}
							disabled={comboRegionDisabled}
							onChange={() => GetConnetionAttribute()}
						/>
					</div>
					<div>
						<TextBoxControl
							inputRef={textBoxUserNameRef}
							title="نام کاربری:"
							required={true}
							onlyNumbers={true}
							placeholder="نام کاربری خود را وارد نمایید"
						/>

						<TextBoxControl
							inputRef={textBoxPasswordRef}
							type="password"
							title="رمز عبور:"
							required={true}
							placeholder="رمز عبور خود را وارد نمایید"
						/>

						<div class="d-flex">
							<div><input id="user_captcha_input" placeholder="کد امنیتی" maxlength="5" class="form-control" name="user_captcha_input" type="text"></input></div>
							<LoadCanvasTemplate />
						</div>

						<ButtonControl
							onClick={LoginSubmit}
							variant="primary"
							title="ورود"
						/>

						<ButtonControl
							onClick={() => navigate("/")}
							variant="danger mx-2"
							title="بازگشت"
						/>
					</div>
				</div>
			</div>
		</div>
	);
}